import React from "react";

const TiptapEditor = ({ content, extensions = [], onUpdate }) => {
    <>사용중지</>
}
export default TiptapEditor;
